// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LugFF","priceContainer":"styles_priceContainer__rG_ov"};